<template>
  <div class="paddingDiv">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-input-group size=" mt-3 mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">
          <md-icon>search</md-icon>
        </span>
      </div>
      <b-form-input
          v-model="filter"
          type="search"
          id="filterInput"
          placeholder="Buscar"
      ></b-form-input>
    </b-input-group>
    <b-table
        responsive
        striped
        hover
        :items="postales"
        :fields="fieldsPaquetes"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        v-bind="postales"
        thead-tr-class="columnas"
    >
      <template v-slot:cell(image)="row" class="">
        <img alt="postales" :src="row.item.image" class="img-fluid imagen"/>
      </template>

      <template v-slot:cell(tipo)="row">
        {{ row.item.tipo }}
      </template>

      <template v-slot:cell(areaNombre)="row" class="text-white">
        {{ row.item.areaNombre }}
      </template>

      <template v-slot:cell(link)="row">
        <template v-if="row.item.link.includes('://')">
          <a :href="row.item.link" target="_blank">Link</a>
        </template>
        <template v-else
        >
          <b>Link invalido</b>
        </template>
      </template>

      <template v-slot:cell(fecha)="row">
        {{ row.item.fecha }}
      </template>

      <template v-slot:cell(editar)="row">
        <router-link
            :to="{
            name: 'postal',
            params: { id: row.item.idPostal },
          }"
        >
          <em class="fa fa-edit"></em>
        </router-link>
      </template>

      <template v-slot:cell(eliminar)="row">
        <b-button variant="primary" @click="eliminar(row.item)">
          <em class="fa fa-trash"></em>
        </b-button>
      </template>
    </b-table>

    <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        aria-controls="my-table1"
    ></b-pagination>
    <br/>
    <br/>
  </div>
</template>

<script>
import moment from "moment";
import miniToastr from "mini-toastr"; //ES6
export default {
  name: "listaPostales",
  props: {
    msg: String,
  },
  components: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    postales: [],
    fieldsPaquetes: [
      {
        key: "image",
        label: "Postal",
        sortable: false,
      },
      {
        key: "tipo",
        label: "Tipo",
        sortable: false,
      },

      {
        key: "areaNombre",
        label: "Área",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "link",
        label: "Link",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "fecha",
        label: "Fecha",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "editar",
        label: "Editar",
      },
      {
        key: "eliminar",
        label: "Eliminar",
      },
    ],
    currentPage: 1,
    perPage: 10,
    filter: null,
    filterOn: [],
    totalRows: 1,
  }),

  methods: {
    eliminar(itm) {
      this.$swal
          .fire({
            title: "¿Estás seguro de eliminar la postal?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {

              this.btnDisabled = true;
              this.$http
                  .post(
                      this.$api +
                      "postal/borradoSuave?idPostal=" + itm.idPostal
                  )
                  .then((response) => {
                    if (response.status === 200) {
                      var message = response.data.message
                          ? response.data.message
                          : "Se guardo correctamente el registro";
                      miniToastr.success(message);
                    }
                    this.obtenerPostales();
                  })
                  .catch((error) => {
                    var message = error.response.data.message
                        ? error.response.data.message
                        : "Error al crear el registro";
                    miniToastr.info(message);
                    this.btnDisabled = false;
                  })
                  .finally(() => {
                    this.btnDisabled = false;
                  });
              //   pendiente
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          })
          .then((result) => {
            if (result.value) {
              this.$swal({
                icon: "success",
                title: "Se elimino correctamente",
                showConfirmButton: false,
                timer: 2500,
              });
            }

            setTimeout(() => this.obtenerPostales(), 4000);
          });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    obtenerPostales() {
      this.$http
          .get(this.$api + "postal/postales")
          .then((response) => {
            if (response.status === 200) {
              this.postales = response.data.data.map(function (el) {
                el.fecha = moment(el.fecha).utc().format("DD/MM/YYYY");
                var o = Object.assign({}, el);
                o.editar = "editar";
                o.eliminar = "eliminar";
                o.image = "data:image/png;base64," + o.dataFile;
                o.tipoSinFormato = o.tipo;
                o.tipo = o.tipo == 1 ? "Anuncio" : "Cumpleaños";
                return o;
              });
              this.totalRows = this.postales.length;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerPostales();
  },
};
</script>

<style scoped>
.paddingDiv {
  padding: 10px;
}

.imagen {
  border-radius: 10px;
  box-shadow: #0d0d0d;
}

</style>
